<template>
  <node-view-wrapper
    contenteditable="false"
    class="editable-shorttag-block"
  >
    <div
      class="content"
      draggable="true"
      data-drag-handle
    >
      <button-link
        :url-part="node.attrs.urlPart"
        :button-name="node.attrs.buttonName"
        @click.native="scrollToTop"
      />
      <button-link-btn
        btn-type="update"
        :url-part-prop="node.attrs.urlPart"
        :button-name-prop="node.attrs.buttonName"
        @update-content="tiptapContentUpdate"
      />
    </div>
  </node-view-wrapper>
</template>

<script>
import {
  NodeViewWrapper,
  nodeViewProps,
} from '@tiptap/vue-2';
import ButtonLink from '../ButtonLink.vue';
import ButtonLinkBtn from './ButtonLinkBtn.vue';

export default {
  components: {
    NodeViewWrapper,
    ButtonLink,
    ButtonLinkBtn,
  },
  props: {
    ...nodeViewProps,
    ...ButtonLink.props,
  },
  methods: {
    tiptapContentUpdate(updateData) {
      this.updateAttributes(updateData.attrs);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>


<style lang="scss" scoped>
.content {
  cursor: grab;
}
</style>
